import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import DialogConfirm from '../../../../../dialog/DialogConfirm';
import usePeriodicalReportSetting from '../../../../../../hooks/periodical-report/usePeriodicalReportSetting';
import { Alert } from '@mui/material';
import FormAssessment from './Form';

const AssessmentAreasDialog = ({ show, onClose, type, formData = {}, onReset, curriculum = [] }) => {
  const types = ['create', 'edit', 'delete', 'preview'];
  const { createSubModule, updateSubModule, deleteSubModule } = usePeriodicalReportSetting();
  const [form, setInputForm] = useState({});
  const [errors, setInputErrors] = useState(null);
  const [loading, toggleLoading] = useState(false);
  const onChange = (name, value) => {
    if (name === 'group') {
      setInputForm((prevForm) => ({
        ...prevForm,
        groupElement: value.groupElement,
        elementId: value.elementId,
        subElementId: value.subElementId
      }));
    } else if (name === 'curriculumId') {
      const { name: curriculumName } = curriculum.find((item) => item._id === value) || {};
      setInputForm({
        _id: form._id,
        curriculumId: value,
        curriculumName,
        type: form.type,
        name: form.name,
        code: form.code
      });
    } else if (name === 'levelsId') {
      setInputForm((prevForm) => {
        let levels = value.map((levelId) => {
            const findLevel = prevForm.levels?.find((level) => level.levelId === levelId);
            if (findLevel) {
              return findLevel;
            }
            return { levelId, definition: '' };
          });
          
        return {
          ...prevForm,
          levelsId: value,
          levels
        };
      });
      setInputErrors((prevErrors) => ({
        ...prevErrors,
        [name]: null
      } ))
    } else {
      setInputForm((prevForm) => ({
        ...prevForm,
        [name]: value
      }));
      setInputErrors((prevErrors) => ({
        ...prevErrors,
        [name]: null
      } ))
    }
  };

  const onSave = async (e) => {
    if (!types.includes(type)) {
      setInputErrors({ message: 'Invalid type' });
      return;
    }
    e.preventDefault();
    toggleLoading(true);
    try {
      let result = { error: false };
      form.levels = form?.levels?.filter((level) => form?.levelsId?.includes(level.levelId)) || [];
      if (type === 'create') {
        result = await createSubModule(form, 'assessment-area');
      }
      if (type === 'edit') {
        result = await updateSubModule(form._id, 'assessment-area', form);
      }
      if (type === 'delete') {
        result = await deleteSubModule(form._id, 'assessment-area');
      }
      if (result.error) {
        setInputErrors(result);
      } else {
        onClose();
        onReset();
      }
    } finally {
      toggleLoading(false);
    }
  };

  useEffect(() => {
    if (formData) {
      const { name: curriculumName } = curriculum?.find((item) => item._id === formData?.curriculumId) || {};
      setInputForm({
        ...formData,
        curriculumName,
        levelsId: formData?.levels?.map((level) => (level.levelId ? level.levelId : level)) || []
      });
    }
  }, [formData]);

  return (
    <DialogConfirm
      id={`${type}-assessment-area`}
      open={show}
      title={`${type} assessment area`}
      onCancel={onClose}
      onConfirm={['create', 'edit', 'delete'].includes(type) ? onSave : undefined}
      textConfirm={type === 'delete' ? 'Confirm' : 'Save'}
      onCloseHeader={type === 'preview'}
      showActions={['create', 'edit', 'delete'].includes(type)}
      loading={loading}
      maxWidth={type === 'delete' ? 'xs' : 'md'}
    >
      {types.includes(type) ? (
        <>
          {type === 'delete' ? (
            <Typography component={'div'}>
              Are you sure you want to delete the assessment area: <b>{form.name}</b>?
            </Typography>
          ) : (
            <div className='grid grid-cols-2 items-start gap-4'>
              <FormAssessment
                form={form}
                errors={errors}
                onChange={onChange}
                type={type}
                curriculumList={curriculum}
              />
            </div>
          )}
        </>
      ) : (
        <Alert severity='error'>Invalid type</Alert>
      )}
      {errors && errors.message && (
        <Alert severity='error' onClose={() => setInputErrors({ message: null })}>
          {errors.message}
        </Alert>
      )}
    </DialogConfirm>
  );
};

export default AssessmentAreasDialog;
